import type { Question } from '../../types';

// ---------------------------------------------------------------------------
// Auto Repair / Service Garage Supplement
// Conditioned on industry_type eq 'auto_service'
// ---------------------------------------------------------------------------

const C = [{ field: 'industry_type', operator: 'eq' as const, value: 'auto_service' }];

export const autoServiceQuestions: Question[] = [
  {
    id: 'auto_services_offered',
    text: 'Which services do you perform?',
    section: 'supplement',
    group: 'auto_operations',
    sort_order: 10,
    field_type: 'multiselect',
    required: true,
    options: [
      { value: 'general_repair', label: 'General mechanical repair' },
      { value: 'body_paint', label: 'Body work / painting' },
      { value: 'tires', label: 'Tires / alignment' },
      { value: 'oil_lube', label: 'Oil / lube / quick service' },
      { value: 'transmission', label: 'Transmission' },
      { value: 'glass', label: 'Auto glass' },
      { value: 'detailing', label: 'Detailing / car wash' },
      { value: 'towing', label: 'Towing' },
    ],
    field_path: 'supplement.auto_service.services',
    conditions: C,
    tags: ['supplement', 'auto_service'],
  },
  {
    id: 'auto_annual_receipts',
    text: 'Annual gross receipts',
    section: 'supplement',
    group: 'auto_financials',
    sort_order: 20,
    field_type: 'currency',
    prefix: '$',
    placeholder: '400000',
    required: true,
    field_path: 'supplement.auto_service.annual_receipts',
    conditions: C,
    tags: ['supplement', 'auto_service'],
  },
  {
    id: 'auto_bays',
    text: 'Number of service bays',
    section: 'supplement',
    group: 'auto_operations',
    sort_order: 30,
    field_type: 'number',
    placeholder: '4',
    required: true,
    validation: { min: 0, max: 100 },
    field_path: 'supplement.auto_service.bays',
    conditions: C,
    tags: ['supplement', 'auto_service'],
  },
  {
    id: 'auto_garagekeepers',
    text: "Do you need Garagekeepers coverage (for customers' vehicles in your care)?",
    section: 'supplement',
    group: 'auto_coverage',
    sort_order: 40,
    field_type: 'boolean',
    required: true,
    field_path: 'supplement.auto_service.garagekeepers',
    conditions: C,
    tags: ['supplement', 'auto_service'],
  },
  {
    id: 'auto_max_vehicles_onsite',
    text: 'Maximum number of customer vehicles on premises at one time',
    section: 'supplement',
    group: 'auto_coverage',
    sort_order: 50,
    field_type: 'number',
    placeholder: '20',
    required: true,
    validation: { min: 0, max: 1000 },
    field_path: 'supplement.auto_service.max_vehicles_onsite',
    conditions: [...C, { field: 'auto_garagekeepers', operator: 'eq', value: true }],
    tags: ['supplement', 'auto_service'],
  },
  {
    id: 'auto_test_drives',
    text: 'Are employees permitted to test-drive customer vehicles?',
    section: 'supplement',
    group: 'auto_operations',
    sort_order: 60,
    field_type: 'boolean',
    required: true,
    field_path: 'supplement.auto_service.test_drives',
    conditions: C,
    tags: ['supplement', 'auto_service'],
  },
  {
    id: 'auto_loaner_vehicles',
    text: 'Do you provide loaner or rental vehicles to customers?',
    section: 'supplement',
    group: 'auto_operations',
    sort_order: 70,
    field_type: 'boolean',
    required: true,
    field_path: 'supplement.auto_service.loaner_vehicles',
    conditions: C,
    tags: ['supplement', 'auto_service'],
  },
  {
    id: 'auto_flammable_storage',
    text: 'Do you store flammable liquids / used oil on site, and are they handled per code?',
    section: 'supplement',
    group: 'auto_protection',
    sort_order: 80,
    field_type: 'select',
    required: true,
    options: [
      { value: 'compliant', label: 'Yes, stored and disposed per code' },
      { value: 'noncompliant', label: 'Stored but not on a formal program' },
      { value: 'none', label: 'No flammable/used oil storage' },
    ],
    field_path: 'supplement.auto_service.flammable_storage',
    conditions: C,
    tags: ['supplement', 'auto_service'],
  },
  {
    id: 'auto_employees',
    text: 'Number of mechanics / technicians',
    section: 'supplement',
    group: 'auto_employees',
    sort_order: 90,
    field_type: 'number',
    placeholder: '5',
    required: true,
    validation: { min: 0, max: 500 },
    field_path: 'supplement.auto_service.technicians',
    conditions: C,
    tags: ['supplement', 'auto_service'],
  },
];
